import { IWedding, Layout } from '@bridebook/models/source/models/Weddings.types';
import { Container } from '@bridebook/ui';
import { usePublicWeddingWebsite } from '@bridebook/web/app-basic/lib/wedding-website/hooks/use-public-wedding-website';
import { Palettes } from '@bridebook/web/lib/wedding-website/types';
import { useRouter } from 'next/router';
import LayoutWebsite from '../layout-website';
import { EditorSyncProvider } from '../main/desktop/editor-sync-context';
import { ViewModeWebsite } from './view-mode-website';
// eslint-disable-next-line no-restricted-imports
import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import { WeddingWebsitePrimaryWithData } from './layouts-v2/layout-primary/wedding-website-primary-with-data';
import { WeddingWebsiteSplitWithData } from './layouts-v2/layout-split/wedding-website-split-with-data';
import { WeddingWebsiteMotifWithData } from './layouts-v2/layout-motif/wedding-website-motif-with-data';
// eslint-disable-next-line no-restricted-imports
import { GetWeddingWebsiteDataResponse } from '@bridebook/web/pages/api/for/website/[websiteId]';

interface GuestViewTestingProps {
  initialWeddingWebsiteData?: GetWeddingWebsiteDataResponse;
}

export const GuestView = ({ initialWeddingWebsiteData }: GuestViewTestingProps) => {
  const router = useRouter();
  const { websiteId } = router.query as { websiteId: string };

  const { data } = usePublicWeddingWebsite(
    websiteId,
    {},
    {
      keepPreviousData: true,
      initialData: initialWeddingWebsiteData,
    },
  );

  if (!data || data.resultCode === 'error') {
    return <div>Error loading website</div>;
  }

  if (data.website.config.layout === Layout.Split) {
    return <WeddingWebsiteSplitWithData dataProvider="guest" />;
  }

  if (data.website.config.layout === Layout.Primary) {
    return <WeddingWebsitePrimaryWithData dataProvider="guest" />;
  }

  if (data.website.config.layout === Layout.Motif) {
    return <WeddingWebsiteMotifWithData dataProvider="guest" />;
  }

  return <GuestViewLegacy initialWeddingWebsiteData={initialWeddingWebsiteData} />;
};

export const GuestViewLegacy = ({ initialWeddingWebsiteData }: GuestViewTestingProps) => (
  <LayoutWebsite initialWeddingWebsiteData={initialWeddingWebsiteData}>
    {({ websiteData, themeStyles }) => (
      // this is required due to using the hooks in section components, breaking the /for/ page if it is missing
      <EditorSyncProvider noop>
        <Container>
          <div className="@container xl:pt-8">
            <ViewModeWebsite
              websiteId={websiteData.website.id}
              suppliers={websiteData.suppliers}
              wedding={
                websiteData.wedding as {
                  date: IWedding['date'];
                  partners: [string, string];
                }
              }
              config={websiteData.website?.config}
              palette={websiteData.website?.config.theme.palette as Palettes}
              sections={websiteData.website.sections}
              events={websiteData.events}
              themeStyles={themeStyles}
              clickedSupplierProfileAnalytics={() => {
                clickedOnLoggedOutPage({
                  clickedLocation: 'weddingWebsites',
                  clickedSection: 'weddingLocation',
                  cta: 'View this venue on Bridebook',
                });
              }}
            />
          </div>
        </Container>
      </EditorSyncProvider>
    )}
  </LayoutWebsite>
);
